import { LineString } from "geojson";
import * as turf from "@turf/turf";

export class StreetSegment {
    constructor(
        public id: number,
        public wayId: number,
        public geometry: LineString,
    ) { }

    static fromObject(obj: {
        id: number,
        wayId: number,
        geometry: LineString,
    }): StreetSegment {
        return new StreetSegment(
            obj.id,
            obj.wayId,
            obj.geometry,
        );
    }

    /**
     * Length in meters
     */
    get length(): number {
        const lineString = turf.lineString(this.geometry.coordinates);
        return turf.length(lineString, { units: 'meters' });
    }
}
